<template>
  <!-- Top NavBar -->
  <div class="top-nav">
    <div class="top-nav-container">
<!--      <i class="fa fa-search icon"></i>-->
<!--      <input class="top-nav-search-input" type="text" placeholder="Поиск...">-->
      <!-- <router-link :to="{ name: 'dashboard' }">
          <button class="try-new-design-btn">Опробовать новый дизайн</button>
      </router-link> -->
      <router-link :to="{ name: 'notification' }">
        <i class="fas fa-bell icon">
          <span class="badge" v-if="this.GETCOUNTNOTIFICATIONS > 0">{{ this.GETCOUNTNOTIFICATIONS }}</span>
        </i>
      </router-link>
      
      <router-link :to="{ name: 'profile' }"
                   style="display: grid; grid-template-columns: 1fr 3fr; text-decoration: none">
        <img class="top-nav-user-avatar" src="@/assets/avatar.png" alt="">
        <p class="top-nav-user-info">{{ USER.last_name | TitleCase }} {{ USER.first_name | TitleCase }}</p>
      </router-link>

    </div>
  </div>
  <!-- Top NavBar End -->
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios'

export default {
  name: 'top-nav-bar',
  data() {
    return {
      notificationCount: ''
    }
  },
  methods: {
    getCountNotification() {
      this.$store.dispatch('getCountNotification');
    },
  },
  mounted() {
    this.getCountNotification();
  },
  computed: {
    ...mapGetters([
      'USER',
      'GETCOUNTNOTIFICATIONS'
    ]),

  },
}
</script>

<style scoped>
/* Top Nav */

.top-nav-container {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  border-bottom: 1px solid #DDDDDD;
  padding: .5rem;
}

.top-nav-search-input {
  width: 70%;
  border: none;
  outline: none;
  background: transparent;
}

.top-nav-user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.top-nav-user-info {
  vertical-align: middle;
  margin: 0 1rem;
  line-height: 3rem;
  font-size: 1.2rem;
}

.top-nav-container .fa-bell {
  color: #383838;
}

.icon {
  padding: .9rem;
  color: #868686;
  min-width: 50px;
  text-align: center;
  font-size: 1.5rem;
}

/* Top Nav END */

.badge {
  color: red;
}

.try-new-design-btn {
  padding: 1rem;
  border-radius: 2rem;
  box-shadow: var(--box-shadow);
  background: var(--color-success);
  color: #fff;
  cursor: pointer;
}
</style>